module.exports = __webpack_public_path__ + "reduct_Lyon.jpg?508bbf0d88f09920376a0c1521ac2300";


//////////////////
// WEBPACK FOOTER
// ./src/img/slider_accueil/reduct/reduct_Lyon.jpg
// module id = 111
// module chunks = 0